<template>
    <div class="data-record data-info">
        <el-row :gutter="10">
            <el-col :span="cols" class="info-parts">
                <span tkey="登錄賬戶">{{i18n.tkey("lang_login_in")}}:&nbsp;</span>
                <span>{{obj.login}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="密碼">{{i18n.tkey("lang_password")}}:&nbsp;</span>
                <span>{{obj.password}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="姓名">{{i18n.tkey("lang_name")}}:&nbsp;</span>
                <span>{{obj.name}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="手機號碼">{{i18n.tkey("lang_mobile_number")}}:&nbsp;</span>
                <span>{{obj.mpfaccount}}&nbsp;{{obj.telephone}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="狀態">{{i18n.tkey("lang_state")}}:&nbsp;</span>
                <span>{{stateName}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="類型">{{i18n.tkey("lang_type")}}:&nbsp;</span>
                <span>{{typeName}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="註冊時間">{{i18n.tkey("lang_reg_date")}}:&nbsp;</span>
                <span>{{obj.mlifetime}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="登錄時間">{{i18n.tkey("lang_login_date")}}:&nbsp;</span>
                <span>{{obj.poslifetime}}</span>
            </el-col>

            <el-col :span="24" class="info-parts">
                <div style="text-align: right">
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        @click="clickBtnFunc('logoff')"-->
<!--                    >-->
<!--                        <span tkey="註銷">{{i18n.tkey("lang_log_off")}}</span>-->
<!--                    </el-button>-->
                </div>
            </el-col>

        </el-row>
    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, computed} from "vue";
import myUtil from "@/util/util";

const props = defineProps(["obj"])
const emits = defineEmits(["clickBtn"])

const i18n = inject("i18n")
const cols = ref(24)

const stateName = computed(() => {
    let name = i18n.tkey("lang_normal")

    if (props.obj.verify != -1)
        name = i18n.tkey("lang_not_active")

    return name
})

const typeName = computed(() => {
    let name = i18n.tkey("lang_user")

    if (props.obj.addinfo6 == "-1"){
        name = i18n.tkey("lang_admin_user")
    }

    return name
})

function clickBtnFunc(name){
    emits("clickBtn", name, props.obj)
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }
})

</script>

<style scoped>
    .data-record {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border: 1px #F0F2F5 solid;
        border-radius: 3px;
    }

    .info-parts {
        margin-bottom: 10px;
    }

    @media screen and (max-width: 520px) {
        .data-info {
            font-size: 12px;
            color: #606266;
        }
    }

    @media screen and (min-width: 520px) {
        .data-info {
            font-size: 14px;
            color: #606266;
        }
    }
</style>